module.exports = __webpack_public_path__ + "h5/img/noCart.23265d51.png";